<template>
  <el-dialog :visible.sync="visible" title="批量修改优先级" width="600px" :before-close="close">
    <div>
      <el-radio v-model="radio" :label="1">
        选中商品的优先级从第
        <el-input size="small" v-model="pageNumber" placeholder="输入页码" @input="e => onInput(e, 'pageNumber')" style="width:100px"></el-input>
        页的第
        <el-input size="small" v-model="orderNum" placeholder="输入位置" @input="e => onInput(e, 'orderNum')" style="width:100px"></el-input>
        条开始插入
      </el-radio>
      <div class="tips">注：当前一页显示{{ pageSize }}条</div>
    </div>
    <div style="margin-top:20px">
      <el-radio v-model="radio" :label="2">
        选中商品的优先级从第
        <el-input size="small" v-model="priority" placeholder="输入优先级" @input="e => onInput(e, 'priority')" style="width:100px"></el-input>
        条开始插入
      </el-radio>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="medium" @click="close">取 消</el-button>
      <el-button type="primary" size="medium" @click="confirm">确 认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    selectIds: {
      type: Array,
      default: () => []
    },
    pageSize: {
      type: Number,
      default: () => 40
    },
    total: {
      type: Number,
      default: () => 0
    },
  },
  data() {
    return {
      visible: false,
      radio: 1,

      pageNumber: 1,
      orderNum: 1,
      priority: 1
    }
  },
  computed: {
    maxPage() {
      return Math.ceil(this.total / this.pageSize) || 1
    },
  },
  methods: {
    show() {
      this.visible = true
    },

    confirm() {
      if (this.radio === 1 && (!this.pageNumber || !this.orderNum)) {
        return this.$message.warning('请输入页码和位置')
      }
      if (this.radio === 2 && !this.priority) {
        return this.$message.warning('请输入优先级')
      }
      let param = {
        update: this.selectIds,
        orderNum: this.radio === 1 ? +this.orderNum : +this.priority
      }
      if (this.radio === 1) {
        param.pageNumber = this.pageNumber
        param.pageSize = this.pageSize
      }
      this.$emit('changePriority', param)
      this.close()
    },
    onInput(e, type) {
      let num = e.replace(/[^\d]/g,'')
      num = (num === '0') ? 1 : num 
      // if (type === 'pageNumber') {
      //   num = num > this.maxPage ? this.maxPage : num
      // }
      if (type === 'orderNum') {
        num = num > this.pageSize ? this.pageSize : num
      }
      this.$set(this.$data, type, num)
    },

    close() {
      this.visible = false
      this.clear()
    },

    clear() {
      this.radio = 1
      this.pageNumber = 1
      this.orderNum = 1
      this.priority = 1
    }
  }
}
</script>

<style lang="scss" scoped>
.tips {
  color: #999;
  font-size: 14px;
  padding-left: 30px;
}
</style>
